export const UserAdjustData = data => {
  let newData = {
    userId: data.userId,
    phone: data.phone,
    phoneVerified: data.phoneVerified,
    lastname: data.lastname,
    name: data.name,
    patronymic: data.patronymic,
    birthDate: data.birthDate,
    birthPlace: data.birthPlace,
    photo: data.photo,
    email: data.email,
    sex: data.sexId && String(data.sexId.sexId),
  };
  if (data.foreignLanguages) {
    newData.foreignLanguages = data.foreignLanguages.map(
      item => item.foreignLanguageKey
    );
  }

  if (data.identityDocumentId) {
    newData.identityDocument = data.identityDocumentId.identityDocumentId;
  }

  if (data.citizenshipId) {
    newData.citizenship = data.citizenshipId.citizenshipId;
  }
  if (newData.phone !== '') {
    let phone = newData.phone.match(/^(\+7|\+380|\+375)(.*)/);
    if (phone) {
      newData.phoneCode = phone[1];
      newData.phone = phone[2];
    }
  }
  return newData;
};
